<template>
  <div class="online-cash-instructions">
    <div class="top-img">
      <img :src="imgObj.topImgBg">
    </div>
    <div class="bottom-box">
      <div class="item-box pad-all">
        <div class="title-img">
          <img :src="imgObj.titleBg">
          <div class="title-span">机构线上收银优势</div>
        </div>
        <div class="item display-flex-start" v-for="item in list" :key="item.id">
          <div class="left">
            <img :src="item.iconName">
          </div>
          <div class="right">
            <div class="top">{{ item.title }}</div>
            <div class="bottom">{{ item.info }}</div>
          </div>
        </div>
      </div>
      <!-- 机构开户关键资料-->
      <div class="item-box">
        <div class="title-img">
          <img :src="imgObj.titleBg">
          <div class="title-span">机构开户关键资料</div>
        </div>
        <div class="tag-box">
          <div class="tag-title">企业商户</div>
          <div class="tag-item-box display-flex-start">
            <div v-for="item in tagList1" :key="item.id" class="tag-item">{{ item }}</div>
          </div>
        </div>
        <div class="tag-box">
          <div class="tag-title">个体工商户</div>
          <div class="tag-item-box display-flex-start">
            <div v-for="item in tagList2" :key="item.id" class="tag-item">{{ item }}</div>
          </div>
        </div>
        <div class="tag-box">
          <div class="tag-title">小微商户</div>
          <div class="tag-item-box display-flex-start">
            <div v-for="item in tagList3" :key="item.id" class="tag-item">{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom display-flex-center">
        <div class="logo">
          <img :src="imgObj.footerLogo">
        </div>
        <div class="font">为青训机构管理提供技术支持</div>
      </div>
    </div>
  </div>
</template>

<script>
// import { applyService } from '@/api/team'
import { ImageFormat } from '@/utils'
export default {
  name: 'onlineCashInstructions',
  data() {
    return {
      imgObj: {},
      list: [
        {
          title: '0费用开通，收银更便捷',
          info: '免费申请开通线上收银，从此收费对账更高效',
          icon: 'FmW-4xwIEGOt9_cxT5N-2Q4kWE3m'
        },
        {
          title: '线上生成账单，多渠道扫码付款',
          info: '可分享收款海报给家长也可现场直接扫码付款',
          icon: 'Fp_jc8ZxvlkqXaga2ipBQ0Oz_BKT'
        },
        {
          title: '结算资金直达账户，安全有保障',
          info: '不经过第三方，直接自动结算至机构公/私账户',
          icon: 'FrVpThKahs78uZpFNg0iDduQPAXH'
        }
      ],
      tagList1: ['营业执照', '组织机构代码证(已三证合一则无须提供)', '银行开户许可证', '同名对公银行账户', '法人身份证'],
      tagList2: ['营业执照', '法人身份证', '同名对公银行账户或法人对私银行账户'],
      tagList3: ['身份证', '同名银行卡']
    }
  },
  created() {
    this.getShare()
  },
  mounted() {
    this.trackingTD('page_cb_miniSite')
    this.imgObj = {
      topImgBg: ImageFormat.squareImageView('FgMZq5yySs9dJbHzJ2l07eHXurSm', 0),
      titleBg: ImageFormat.squareImageView('Fm8PpMtkms3gvDJr-SCQ7961twUD', 0),
      footerLogo: ImageFormat.squareImageView('FjYhfCuKz7G3s5OiGheC67c30atw', 0)
    }
    const list = this.list
    list.map(item => {
      item.iconName = ImageFormat.squareImageView(item.icon, 0)
    })
    this.list = list
  },
  methods: {
    //  分享
    getShare() {
      const url = this.getShareLink()
      this.shareData = {
        title: '免费开通邦教练线上收银',
        link: url,
        image: ImageFormat.squareImageView('FgMZq5yySs9dJbHzJ2l07eHXurSm', 120),
        abstract: '助力机构线上收银三大优势，免费开通机不可失！'
      }
      this.wxShare(this.shareData)
    },
    getShareLink: function () {
      const arr = window.location.href
      return arr
    }
  }
}
</script>

<style lang="scss">
  .online-cash-instructions{
    position: relative;
    min-height: 100%;
    .top-img{
      width: 100%;
      height: 350px;
      img{
        width: 100%;
        height: 350px;
      }
    }
    .bottom-box{
      width: 100%;
      min-height: 300px;
      background-color: #FFFFFF;
      border-radius: 20px 20px 0px 0px;
      position: absolute;
      top: 194px;
      padding-bottom: 60px;
      .item-box{
        width: 334px;
        min-height: 283px;
        border: 1px solid rgb(188, 220, 254);
        border-radius: 10px;
        margin: 30px auto 0;
        &.pad-all{
          padding: 0 14px;
          box-sizing: border-box;
        }
        .title-img{
          width: 100%;
          height: 45px;
          position: relative;
          img{
            width: 176px;
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
            margin-top: -5px;
          }
          .title-span{
            font-size: 16px;
            font-weight: bold;
            position: absolute;
            left: 50%;
            padding-top: 3px;
            box-sizing: border-box;
            transform: translate(-50%, 0);
            color: #FFFFFF;
            margin-top: -5px;
          }
        }
        .tag-box{
          margin-bottom: 27px;
          .tag-title{
            font-size: 14px;
            color: #303239;
            font-weight: bold;
            padding-left: 14px;
            box-sizing: border-box;
          }
          .tag-item-box{
            flex-wrap: wrap;
            .tag-item{
              background-color: #E3F0FF;
              padding: 3px 6px;
              display: inline-block;
              border-radius: 2px;
              color: #1B85FF;
              font-size: 12px;
              margin-left: 14px;
              margin-top: 10px;
            }
          }
        }
        .item{
          margin-bottom: 32px;
          .left{
            margin-right: 10px;
            img{
              width: 50px;
              height: 50px;
            }
          }
          .right{
            .top{
              font-size: 14px;
              color: #303239;
              font-weight: bold;
            }
            .bottom{
              color: #989B9E;
              font-size: 12px;
              margin-top: 8px;
            }
          }
        }
      }
    }
    .footer-bottom{
      width: 100%;
      position: absolute;
      bottom: 26px;
      .logo{
        img{
          width: 40px;
        }
      }
      .font{
        color: #CCCCCC;
        font-size: 10px;
      }
    }
    input::-webkit-input-placeholder {
      font-size: 16px;
      color: #8D90AE;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/online-cash-instructions/index.vue